import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { COMMUNITY_API } from '../../../../app.token';

@Injectable( {
    providedIn: 'root'
} )
export class CommunityConsentService {
    /** ignore in coverage */
    #apiUrl = inject( COMMUNITY_API );
    #httpClient = inject( HttpClient );

    /**
     * Get organization consent for Scope community
     * @param communityId - The ID of the organization
     * @returns An observable of the current consent status
     */
    getCommunityConsent( communityId: string ): Observable<boolean> {
        return this.#httpClient
            .get<boolean>( `${this.#apiUrl}/consent/${communityId}` )
            .pipe(
                map( ( response: boolean ) => response ),
                catchError( ( error ) => {
                    // console.error( 'Error getting community consent:', error );
                    return of( false );
                } )
            );
    }

    /**
     * Set organization consent for Scope community
     * @param communityId - The ID of the organization
     * @param consent - The consent status
     * @returns An observable of the updated consent status
     */
    setCommunityConsent( communityId: string, consent: boolean ) {
        const headers = new HttpHeaders( {
            'Content-Type': 'text/plain; charset=utf-8'
        } );
        const body = String( !!consent ); // "true" or "false"

        return this.#httpClient
            .put<boolean>( `${this.#apiUrl}/consent/${communityId}`, body, {
                headers
            } )
            .pipe(
                map( ( response ) => response ),
                catchError( ( error ) => {
                    // console.error( 'Setting community consent failed:', error );
                    return of( false );
                } )
            );
    }

}
